import * as React from "react";
import {cx} from "emotion";

import "./delivery-methods.scss";

import { CheckShowPricing } from "@Common/logic/check-show-pricing";
import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";

// shipping (reversed), download, map-marker
export const DeliveryMethods = ({state, avaiMethods, pricingTableModal}) => cs(
    (_, next) => avaiMethods.length === 0 ? (
        <div className="delivery-methods-8d3">
            <div className="card error">
                This template does not currently have delivery options configured. Please choose another template or contact customer service.
            </div>
        </div>
    ) : (
        next()
    ),
    consumeContext("templateOptions"),
    ({}) => (
        <div className="delivery-methods-8d3">
            <div className="header">
                <div className="title">
                    Delivery Options
                </div>
                {cs(
                    ({}, next) => CheckShowPricing({next}),
                    () => (
                        <div className="actions">
                            <a
                                onClick={() => pricingTableModal.show()}
                                xd-qa-type="link"
                                xd-qa-name="Pricing Table"
                            >Pricing Table</a>
                        </div>
                    ),
                )}
            </div>

            <div className="card">
                <div className="methods">
                    {methods.filter((m) => avaiMethods.includes(m.name)).map((m) => {
                        const selected = state.value === m.name;
                        return (
                            <div
                                className={cx("method", {selected})}
                                key={m.name}
                                onClick={() => state.onChange(m.name)}
                                xd-qa-type="button"
                                xd-qa-name={m.label}
                            >
                                <i className={"fa fa-" + m.icon}/>
                                <div className="label">
                                    {m.label}
                                </div>

                                {selected && (
                                    <div className="check">
                                        <i className="fa fa-check-circle"/>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
);

const methods = [
    {
        name: "mailing",
        label: "Mail",
        icon: "envelope",
    },
    {
        name: "shipping",
        label: "Ship",
        icon: "truck",
    },
    {
        name: "download",
        label: "Download",
        icon: "download",
    },
    {
        name: "pickup",
        label: "Pickup",
        icon: "map-marker",
    },
];
